import { LoginConsts } from 'client/util/Constants';
import { get } from 'lodash';
import MfaApiResponseHandler from 'client/containers/Login/MfaApiResponseHandler';

const { responseMessages } = LoginConsts;
const {
  loginError,
  mfaRequired,
  mfaUnavailableForPwdReset,
  passwordResetError,
} = responseMessages;

export const loginErrorHandler = (error = { response: { data: { message: loginError } } }) => {
  const { response } = error;
  const message = get(response, 'data.message', loginError);
  const factors = get(response, 'data.factors', []);

  if (message !== mfaRequired) {
    return Error(message);
  }

  return { factors };
};

const defaultPasswordResetError = { response: { data: { message: passwordResetError } } };

export const passwordResetErrorHandler = (error = defaultPasswordResetError) => {
  const { response } = error;
  const message = get(response, 'data.message', passwordResetError);
  const factors = get(response, 'data.factors', []);
  const challenge = get(response, 'data.challenge', undefined);
  const pwdResetToken = get(response, 'data.pwdResetToken', '');

  // TODO: Determine if we can reuse `mfaRequired` error message for password
  // reset attempts with no available factors.
  // See https://github.com/TheJumpCloud/SI/blob/master/routes/webui/systemusers.js#L361-L369
  if (message !== mfaRequired && message !== mfaUnavailableForPwdReset) {
    return Error(message);
  }

  return { factors, challenge, pwdResetToken };
};

export default {
  methods: {
    loginSuccessHandler(url) {
      this.redirect(url);
      return url;
    },

    passwordResetSuccessHandler(url) {
      this.redirect(url);
      return url;
    },

    setErrorMessage(message = loginError) {
      this.errorMessage = message;
      return this.errorMessage;
    },

    mfaRedirectHandler(mfa, options) {
      return this.$router.push(MfaApiResponseHandler(mfa, options));
    },
  },
};
